<template>
  <v-dialog v-model="show" width="550">
    <v-card class="poll-card">
      <v-card-title class="title justify-space-between">
        <div>Poll Details</div>
        <v-spacer></v-spacer>
        <v-icon color="white" @click="closeDialog">mdi-close</v-icon>
      </v-card-title>
      <v-card-text class="mt-5">
        <div>Category*</div>
        <v-radio-group v-model="selectedRadio" row>
          <v-radio label="Stock" value="stock"></v-radio>
          <v-radio label="Market" value="market"></v-radio>
          <v-radio label="Industry" value="industry"></v-radio>
          <v-radio label="Others" value="others"></v-radio>
        </v-radio-group>
        <v-form ref="form">
          <div v-if="selectedRadio !== 'others'">Poll Title*</div>
          <v-autocomplete
            v-if="selectedRadio == 'stock'"
            placeholder="Select Stock"
            dense
            hide-no-data
            outlined
            :items="securities"
            :item-text="getItemText"
            item-value="symbol"
            v-model="security"
            @keyup="(e) => getSecurity(e.target.value)"
          >
            <template slot="item" slot-scope="data">
              <!-- HTML that describe how select should render items when the select is open -->
              <div>
                <div>{{ data.item.symbol }}:{{ data.item.exchange }}</div>
                <div class="security_name__class">
                  {{ data.item.name }}
                </div>
              </div>
            </template>
          </v-autocomplete>
          <v-autocomplete
            v-if="selectedRadio == 'market'"
            placeholder="Select Market"
            v-model="market"
            dense
            outlined
            :items="markets"
          ></v-autocomplete>
          <v-autocomplete
            placeholder="Select Industry"
            v-if="selectedRadio == 'industry'"
            v-model="industry"
            :items="industries"
            dense
            outlined
          ></v-autocomplete>
          <div>Poll Question*</div>
          <v-text-field
            v-model="question"
            dense
            outlined
            placeholder="Enter Question"
          ></v-text-field>
          <div>Poll Options</div>
          <!-- <v-text-field v-model="opt1" dense outlined placeholder="Enter Poll Option 1"></v-text-field>
                    <v-text-field v-model="opt2"  dense outlined placeholder="Enter Poll Option 2"></v-text-field> -->
          <v-text-field
            v-model="pollOptions[0].value"
            dense
            outlined
            placeholder="Enter Poll Option 1"
          ></v-text-field>
          <v-text-field
            v-model="pollOptions[1].value"
            dense
            outlined
            placeholder="Enter Poll Option 2"
          ></v-text-field>
          <div
            v-for="(option, index) in pollOptions.slice(
              2,
              2 + addedOptionsCount
            )"
            :key="option.id"
            class="d-flex align-center mb-2"
          >
            <v-text-field
              v-model="option.value"
              dense
              outlined
              :placeholder="'Enter Poll Option ' + (index + 3)"
            ></v-text-field>
            <v-icon
              class="ml-3 mb-6"
              color="primary"
              @click="removeOption(index + 2)"
              >mdi-close-box-outline</v-icon
            >
          </div>

          <!-- Add More Options Button (Hidden after 6 options) -->
          <v-btn
            v-if="pollOptions.length < 6"
            outlined
            color="primary"
            block
            class="text-none"
            @click="addOption"
          >
            <v-icon class="mr-2">mdi-plus-box-outline</v-icon>Add More Options
          </v-btn>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-row no-gutters>
          <v-col cols="6" class="px-1">
            <v-btn outlined color="primary" block @click="closeDialog"
              >Back</v-btn
            >
          </v-col>
          <v-col cols="6" class="px-1">
            <v-btn color="primary" block @click="createPoll">Save</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Axios from "@/api/BaseAxios";
import newAxios from "@/api/newAxios";
import apiUrl from "@/common/apiUrl";
export default {
  name: "UploadPollDialog",
  data() {
    return {
      securities: [],
      selectedRadio: "stock",
      market: "",
      markets: ["US Market", "Indian Market", "Global Market"],
      security: "",
      industry: "",
      question: "Are you bearish or bullish on this stock today?",
      opt1: "",
      opt2: "",
      industries: [
        "Healthcare",
        "Utilities",
        "Communication Services",
        "Real Estate",
        "Consumer Discretionary",
        "Energy Industry",
        "Industrials",
        "Consumer Staples",
        "Information Technology",
        "Building Material",
        "Financials",
        "Banks",
        "Electronic Technology",
        "Finance",
        "Materials Sector",
        "Automobile",
        "Transportation",
        "Agriculture",
        "Aviation",
        "Consumer Durables",
        "Consumer Services",
        "Pharmaceutics",
        "Retail",
        "Abrasives",
      ],
      pollOptions: [
        { id: 1, value: "Bullish" },
        { id: 2, value: "Bearish" },
        { id: 3, value: "" },
      ],
      addedOptionsCount: 0,
    };
  },
  computed: {
    show() {
      return this.$store.state.poll.postPoll.show;
    },
  },
  watch: {
    selectedRadio(newVal) {
      switch (newVal) {
        case "stock":
          this.question = "Are you bearish or bullish on this stock today?";
          break;
        case "market":
          this.question = "Are you bearish or bullish on this market today?";
          break;
        case "industry":
          this.question = "Are you bearish or bullish on this industry today?";
          break;
        case "others":
          this.question = ""; // Clear the question field
          break;
      }
    },
  },
  methods: {
    createPoll() {
      const onSuccess = () => {
        this.closeDialog();
        window.location.reload();
      };
      const onFailure = () => {};
      let formData = {};
      if (this.selectedRadio == "stock") {
        formData["title"] = this.security;
      }
      if (this.selectedRadio == "market") {
        formData["title"] = this.market;
      }
      if (this.selectedRadio == "industry") {
        formData["title"] = this.industry;
      }
      if (this.selectedRadio == "others") {
        formData["title"] = "others";
      }
      formData["question"] = this.question;
      formData["category"] = this.selectedRadio;
      formData["poll_options"] = this.pollOptions
        .filter((option) => option.value.trim() !== "") // Filter out empty options
        .map((option) => ({ option_text: option.value }));
      newAxios("post", apiUrl.CREATE_POLL, {
        data: formData,
        onSuccess,
        onFailure,
        isTokenRequired: true,
      });
    },
    addOption() {
      if (this.pollOptions.length < 6) {
        const newOption = { id: Date.now(), value: "" };
        this.pollOptions.push(newOption);
        this.addedOptionsCount += 1;
      }
    },
    removeOption(index) {
      this.pollOptions.splice(index, 1);
      if (this.addedOptionsCount > 0) {
        this.addedOptionsCount -= 1;
      }
    },
    closeDialog() {
      // this.resetForm();
      this.$store.commit("poll/togglePollModal", { show: false });
    },
    resetForm() {
      this.selectedRadio = "stock";
      this.pollOptions = [
        { id: 1, value: "Bullish" },
        { id: 2, value: "Bearish" },
        { id: 3, value: "" },
      ];
      this.security = "";
      this.market = "";
      this.industry = "";
      this.question = "Are you bearish or bullish on this stock today?";
    },
    getItemText(item) {
      return `${item.symbol}:${item.exchange}`;
    },
    getSecurity(val) {
      if (!val || val.length == 0) {
        this.securities = [];
        return;
      }

      const successHandler = (res) => {
        this.securities = res.data;
      };
      const errorHandler = () => {};
      Axios.request_GET(
        `api/trade/security_search/${val}`,
        // `api/trade/security_search/`,
        {},
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },
  },
};
</script>
<style scoped>
.poll-card {
  min-height: 600px;
  /* Set a fixed or min height */
  max-height: 600px;
  /* Prevent it from growing too large */
  overflow-y: auto;
  /* Make the content scrollable if it exceeds the height */
}

.title {
  color: #fff;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.625rem;
  /* 130% */
  background: var(--Primary-Blue, #2d8cff);
}

.security_name__class {
  color: #333333de;
  font-weight: 500;
  font-size: 13px;
  line-height: 17.76px;
}
</style>
